import React from 'react'
import { translatable } from 'react-instantsearch-core'
import TextLink from '@bit/atd.web.text-link'

type ItemsPops = {}[]

type PropTypes = {
  items: ItemsPops
  canRefine: boolean
  refine: (items: any) => void
  translate: (item: string) => any
}

const ClearRefinements = (props: PropTypes) => {
  const { items, canRefine, refine, translate } = props

  return (
    canRefine && (
      <div>
        <TextLink
          onClick={(e) => {
            e && e.preventDefault()
            refine(items)
          }}
          href="#"
          variant="secondary"
        >
          {translate('reset')}
        </TextLink>
      </div>
    )
  )
}

export default translatable({
  reset: 'Clear All Filters',
  // @ts-ignore
})(ClearRefinements)
